/**
 * @description 发送消息外壳组件
 */

import {h} from 'preact';
import './send-wrap.scss';
import MsgStatus from '../msg-status/msg-status';

export default ({children, session, ...props})=>{
  return(
    <div class='msg__swrap'>
      <MsgStatus 
        status={props.status} 
        onErrClick={props.onErrClick}
      />
      
      <div class='msg__swrap--content'>
        <span class='msg__right--icon'/>

        {children}
      </div>

      <img src={session.portrait} alt="portrait" class='msg__swrap--portrait'/>
    </div>
  )
}


/** WEBPACK FOOTER **
 ** ./components/message/send-wrap/send-wrap.jsx
 **/